/* Predefined delivery radius options that match the most common US
 * restaurant configurations. Used by both Onboarding Setup and the
 * Dashboard Settings → Delivery section. Default = 5 mi (median of the
 * options + matches what most independent restaurants pick in practice).
 */
export const DELIVERY_RADIUS_OPTIONS = [
  { value: 3, label: '3 miles' },
  { value: 5, label: '5 miles' },
  { value: 7, label: '7 miles' },
  { value: 10, label: '10 miles' },
  { value: 15, label: '15 miles' },
];

export const DEFAULT_DELIVERY_RADIUS = 5;
